import { PageId } from 'constants/pages'
import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzXmas65 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_XMAS_65: Record<
  Exclude<PageIdWoofzXmas65, PageIdWoofzXmas65.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageId.SUBSCRIPTIONS_XMAS_65]: {
    id: PageId.SUBSCRIPTIONS_XMAS_65,
    hasHeader: false,
  },
  [PageId.CHAT_UPSELL_XMAS_65]: {
    id: PageId.CHAT_UPSELL_XMAS_65,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_XMAS_65]: {
    id: PageId.UPSELL_XMAS_65,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.DOWNLOAD_XMAS_65]: {
    id: PageId.DOWNLOAD_XMAS_65,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
